import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import TabNav from '../../../components/tabNav';
import Content from './content';

class GlobalNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const { globalNewsTab, globalNewsContent, globalNewsAd } = content;

        const globalNewsData = {
            globalNewsContent,
            globalNewsAd,
        };

        return (
            <div className={styles.wrap}>
                <Chip id="50017" type="struct" title="全球趣闻tab" groupName="正文" content={globalNewsTab}>
                    <TabNav />
                </Chip>

                <Content content={globalNewsData} />
            </div>
        );
    }
}

export default errorBoundary(GlobalNews);
